<template>
    <div class="popup popup-bankProcess" :class="{ 'modal-in': isShow, 'modal-out': !isShow}"  id="downpayPopup">
        <div class="shorexDetail-title js-returnShorexBtn">
            <p>支付订金</p>
            <a class="shorexDetail-returnButton" @click="onGoBack()">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/arrowRightBlack.png">
            </a>
        </div>
        <div class="popupover2-box scroll-container js-smartScroll" v-if="!isNrp">
            <p>通过“皇家加勒比国际游轮”中国大陆官方网站、微信小程序和电话预订适用航次，除了一次性支付订单全款外，还可以选择“订金人民币1000元/人起+尾款”的支付方式，具体要求如下：</p>
            <p>1. 适用航次：中国大陆母港出发的所有航次，具体航次和舱房以预订当时的在售情况和实际库存为准。</p>
            <p>2. 适用时间：在开航日60天(不含)前。部分航线因销售及库存等原因，可能提前关闭订金支付。</p>
            <p>3. 预订后，可以先支付订金人民币1000元/人，享受星际、天际、海际权益的房型将收取船费全款10%或1000元人民币/人（二者取其高）作为订金，尾款于预订航次开航45天（不含）前支付即可。</p>
            <p>4. 如未在开航45天（不含）前支付尾款的，订单会被自动取消，已支付的订金将会按原付款渠道退回。</p>
            <p>5. 预订时提交出行人信息，并至少保持一名出行人信息自提交之日起不变。</p>
            <p>6. 本活动不可与订金膨胀活动、通兑活动等同享。</p>
        </div>
        <div class="popupover2-box scroll-container js-smartScroll" v-else>
            <p>通过“皇家加勒比国际游轮”中国大陆官方网站、微信小程序和电话预订适用航次，除了一次性支付订单全款外，还可以选择“订金人民币1000元/人起+尾款”的支付方式，具体要求如下：</p>
            <p>1. 适用航次：中国大陆母港出发的所有航次，具体航次和舱房以预订当时的在售情况和实际库存为准。</p>
            <p>2. 适用时间：在开航日60天(不含)前。部分航线因销售及库存等原因，可能提前关闭订金支付。</p>
            <p>3. 预订后，可以先支付订金人民币1000元/人，享受星际、天际、海际权益的房型将收取船费全款10%或1000元人民币/人（二者取其高）作为订金，尾款于预订航次开航45天（不含）前支付即可。</p>
            <p>4. 如未在开航45天（不含）前支付尾款的，订单会被自动取消，普通房型将收取1000元人民币/人作为取消费用；享受星际、天际、海际权益的房型将收取船费全款10%或1000元人民币/人（二者取其高）作为取消费用（不包括港务税费）</p>
            <p>5. 预订时提交出行人信息，并至少保持一名出行人信息自提交之日起不变。</p>
            <p>6. 本活动不可与订金膨胀活动、通兑活动等同享。</p>
        </div>

    </div>
</template>

<script>
export default {
    name: "DownPayPopup",
    props: {
        isShow: {
            type: Boolean,
            default () {
                return false
            }
        },
        isNrp: {
            type: Boolean,
            default () {
                return false
            }
        },
        onGoBack: {
            type: Function
        },
    }
}
</script>

<style lang="less" scoped>
#downpayPopup.popup {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(100%, 0, 0);
    display: block;
    z-index: 10401;
}
#downpayPopup.modal-in {
    position: fixed;
    background-color: #F6F7F8;
    transform: translate3d(0, 0, 0);
}
#downpayPopup.modal-out {
    transform: translate3d(100%, 0, 0);
}

#downpayPopup {
    .shorexDetail-title {
        padding: 15px 20px;
        background-color: #fff;
        overflow: hidden;
        text-align: center;
        margin-bottom: 10px;
        position: fixed;
        width: 100%;
        z-index: 10;
        > p {
            
            font-size: 14px;
            color: #333333;
            letter-spacing: 1px;
            text-align: center;
            margin: 0;
        }
        .shorexDetail-returnButton {
            width: 30px;
            position: absolute;
            top: 15px;
            left: 20px;
            text-align: left;
            img {
                width: 33%;
            }
        }
    }

    .popupover2-box {
        -webkit-box-flex: 1;
        -webkit-flex: 1;
        -moz-box-flex: 1;
        -ms-flex: 1;
        flex: 1;
        margin-top: 51px;
        padding: 14px 20px 8px;
        overflow-y: auto;
        background-color: #fff;
        p {
            font-size: 12px;
        }
    }
}
</style>

